'use strict';

const markerClick = (marker) => {
  const pos = marker.position;
  const lat = typeof pos.lat === 'function' ? pos.lat() : pos.lat;
  const lng = typeof pos.lng === 'function' ? pos.lng() : pos.lng;
  const url = `https://maps.google.com/maps?q=loc:${lat},${lng}`;
  window.open(url, '_blank');
};

const defaultOptions = {
  styles: [],
  icon: '',
  onMarkerClick: markerClick,
}

let map, marker, mapId, latitude, longitude, zoom, hasItinerary, itineraryAutocomplete, mapIdentifier, startInput,
  destinationInput, modeSelect, currentMode, directionsDisplay;

const initMap = (options = defaultOptions) => {
  const mapContainers = document.querySelectorAll('.tc-neos-elements-map');

  mapContainers.forEach(mapContainer => {
    mapId = mapContainer.dataset.mapId;
    latitude = parseFloat(mapContainer.dataset.mapLatitude);
    longitude = parseFloat(mapContainer.dataset.mapLongitude);
    zoom = parseInt(mapContainer.dataset.mapZoom);
    hasItinerary = mapContainer.dataset.mapItinerary === 'true';
    itineraryAutocomplete = mapContainer.dataset.mapItineraryAutocomplete === 'true';

    map = new google.maps.Map(mapContainer.querySelector('.map-container'), {
      center: {lat: latitude, lng: longitude},
      zoom: zoom,
      scrollwheel: false,
      mapId: mapId ? mapId : null,
      styles: mapId ? null : options.styles
    });

    marker = new google.maps.marker.AdvancedMarkerElement({
      map: map,
      position: {lat: latitude, lng: longitude},
      content: options.icon ? createCustomMarker(options.icon) : undefined
    });

    marker.addListener('click', () => {
      options.onMarkerClick ? markerClick(marker) : options.onMarkerClick(marker);
    });

    const createCustomMarker = (iconUrl) => {
      const img = document.createElement('img');
      img.src = iconUrl;
      img.style.width = '32px'; // adapte à ta taille
      img.style.height = '32px';
      return img;
    }

    if (hasItinerary) {
      initItinerary(mapContainer);

      if (itineraryAutocomplete) {
        new google.maps.places.Autocomplete(
          document.querySelector('#map_start' + mapContainer.dataset.mapIdentifier),
          {
            componentRestrictions: {
              country: 'ch'
            }
          }
        );
      }
    }
  });
}

const initItinerary = (mapContainer) => {
  mapIdentifier = mapContainer.dataset.mapIdentifier;
  startInput = mapContainer.querySelector('#map_start' + mapIdentifier);
  destinationInput = mapContainer.querySelector('#map_destination' + mapIdentifier);
  directionsDisplay = new google.maps.DirectionsRenderer({
    map: map,
    panel: mapContainer.querySelector('#map_itineraryDescription' + mapIdentifier)
  });
  modeSelect = mapContainer.querySelector('[name=map_mode' + mapIdentifier + ']');
  currentMode = modeSelect.value;
  const printButton = mapContainer.querySelector('#map_print' + mapIdentifier);
  const getItineraryButton = mapContainer.querySelector('#map_getItinerary' + mapIdentifier);

  startInput.addEventListener('keyup', () => {
    if (startInput.value !== '') {
      printButton.classList.remove('disabled');
      getItineraryButton.classList.remove('disabled');
    } else {
      printButton.classList.add('disabled');
      getItineraryButton.classList.add('disabled');
    }
  });

  getItineraryButton.addEventListener('click', () => {
    getItinerary()
  });

  modeSelect.addEventListener('change', () => {
    currentMode = modeSelect.value;
    return false;
  });

  printButton.addEventListener('click', () => {
    let mode = 'd';
    switch (currentMode) {
      case 'WALKING':
        mode = 'w';
        break;
      case 'BICYCLING':
        mode = 'b';
        break;
      case 'TRANSIT':
        mode = 'r';
        break;
      case 'DRIVING':
        mode = 'd';
        break;
    }

    let start = startInput.value;

    if (!start && startInput.dataset.latitude && startInput.dataset.longitude) {
      start = startInput.dataset.latitude + "," + startInput.dataset.longitude;
    }

    let dest = destinationInput.value;

    if (!dest && destinationInput.dataset.latitude && destinationInput.dataset.longitude) {
      dest = destinationInput.dataset.latitude + "," + destinationInput.dataset.longitude;
    }
    var link = "https://www.google.com/maps/dir/?saddr=" + start + "&daddr=" + dest + "&dirflg=" + mode + "&pw=2";
    window.open(link);
  });
}

const getItinerary = () => {
  const directionsService = new google.maps.DirectionsService();
  var start = startInput.value;
  var destination = destinationInput.value;

  if (destination === "") {
    destination = new google.maps.LatLng(latitude, longitude);
  }

  const request = {
    origin: start,
    destination: destination,
    travelMode: google.maps.DirectionsTravelMode[currentMode]
  };

  directionsService.route(request, function (response, status) {
    if (status === google.maps.DirectionsStatus.OK) {
      cleanMarkers();
      directionsDisplay.setDirections(response);
    }
  });
}

const cleanMarkers = () => {
  marker.setMap(null);
}

export default {initMap};
window.initMap = initMap;
